import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ThemeLayout from "./components/layouts/themeLayout";
import ClientProvider from "./state/ClientProvider";
import SignIn from "./components/SignIn";
import Report from "./components/report/Report";
import Jobs from "./components/jobs/Jobs";
import JobSeeker from "./components/jobSeeker/JobSeeker";
import Companies from "./components/companies/Companies";
import DashboardLayout from "./components/layouts/DashboardLayout";
import AuthCheckerLayout from "./components/layouts/authCheckerLayout";
import PrivateLayoutAdmin from "./components/layouts/privateLayoutAdmin";
import MessageContent from "./components/messageContent/MessageContent";
import TemplatesBody from "./components/teamplates/TemplatesBody";
import CreateTemplateEditor from "./components/teamplates/documentTemplate/CreateTemplateEditor";
import LogViewer from "./components/logViewer/LogViewer";
import JobPromotions from "./components/jobPromotion/JobPromotions";
import CandidateTransfer from "./components/CandidateTransfer/CandidateTransfer";
import WhatsappBusiness from "./components/whatsapp/WhatsappBusiness";
import Actions from "./components/actions/Actions";
import Announcements from "./components/announcements/Announcements";

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <AuthCheckerLayout>
                <SignIn />
            </AuthCheckerLayout>
        ),
    },
    {
        path: "/dashboard",
        element: (
            <PrivateLayoutAdmin>
                <DashboardLayout />
            </PrivateLayoutAdmin>
        ),
        children: [
            {
                path: "",
                element: <Jobs />,
            },
            {
                path: "jobs",
                element: <Jobs />,
            },
            {
                path: "companies",
                element: <Companies />,
            },
            {
                path: "job-seeker",
                element: <JobSeeker />,
            },
            {
                path: "message-content",
                element: <MessageContent />,
            },
            {
                path: "announcements",
                element: <Announcements />,
            },
            {
                path: "tt",
                element: <CandidateTransfer />,
            },
            {
                path: "templates",
                element: <TemplatesBody />,
            },
            {
                path: "job-promotions",
                element: <JobPromotions />,
            },
            {
                path: "report",
                element: <Report />,
            },
            {
                path: "whatsapp",
                element: <WhatsappBusiness />,
            },
            {
                path: "logs",
                element: <LogViewer />,
            },
            {
                path: "regenerate-report",
                element: <Actions />,
            },
        ],
    },
    {
        path: "/dashboard/docuemt-template",
        element: <CreateTemplateEditor />,
    },
]);

function App() {
    return (
        <ThemeLayout>
            <ClientProvider>
                <Toaster position="top-right" />
                <RouterProvider router={router} />
            </ClientProvider>
        </ThemeLayout>
    );
}

export default App;
